import styled from "styled-components";

export const SidebarContainer = styled.div`
  & > * {
    position: ${({ position }) => position};
    overflow: hidden;
    ${({ dialogPositionCss }) => {
      if (dialogPositionCss && Object.keys(dialogPositionCss).length) {
        return Object.entries(dialogPositionCss)
          .map(([key, value]) => `${key}: ${value}`)
          .join("; ");
      }
      return `
        top: 56px;
        bottom: 0;
      `;
    }}
  }
`;

export const ScrollContainer = styled.div`
  .simplebar-content {
    height: initial;
  }
`;

export const Content = styled.div`
  height: calc(100% - 45px);
  width: 100%;
  padding-top: 10px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const VideoPreview = styled.video`
  height: 100%;
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
`;

export const ImagesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  user-select: none;
  width: 100%;
`;

export const MasonryContainer = styled.div`
  display: flex;
  gap: 6px;

  & > div {
    display: flex;
    flex-direction: column;
    height: min-content;
    gap: 6px;
  }
`;

export const ShowMoreButton = styled.div`
  margin: 20px 0 20px;
  color: ${({ theme }) => theme.text.link};
  cursor: pointer;
  text-align: center;
  font-weight: 500;
  font-size: 14px;

  &:hover {
    opacity: 0.9;
  }
`;

export const ImageThumbnail = styled.div`
  position: relative;
  cursor: grab;
  border-radius: 4px;
  display: grid;
  place-content: center;
  user-select: none;

  & > img {
    display: block;
    width: 122.5px;
    height: ${({ height }) => height || "auto"};
    border-radius: 2px;
    background: #00000011;
    object-fit: cover;
  }

  & > span {
    display: ${({ isSelected }) => (isSelected ? "flex" : "none")};
    position: absolute;
    height: 14px;
    width: 14px;
    left: 2px;
    top: 2px;
    z-index: 1;
    background: #23a5f7;
    color: #fff;
    border-radius: 50%;
  }

  &:hover {
    & > img {
      filter: brightness(0.8);
    }

    & > div,
    & > a {
      display: flex;
    }
  }
`;

export const ImageAttribution = styled.a`
  display: none;
  flex-direction: row;
  align-items: center;
  position: absolute;
  bottom: 6px;
  left: 6px;
  right: 6px;
  color: #fff;

  img {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  span {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ImageLinkPreview = styled.div`
  background: ${({ link }) => `url("${link}")`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0% 50%;
  width: 100%;
  height: 100%;
  min-height: 250px;
`;

export const Label = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.text.text};
`;
